import SvgColor from './lib/component/SvgColor'

export default SvgColor